export type AiService = 'chatgpt' | 'claude' | 'perplexity' | 'gemini';

type PromptInput = {
  sourceUrl: string;
  introduction: string;
  brandStatement: string;
  /**
   * What the reader is asking the AI to do with the case. Optional because the
   * prompt is still usable without it, and an empty string must not leave a
   * blank line in the middle of the prompt.
   */
  question?: string;
};

const AI_SERVICE_URLS: Record<AiService, string> = {
  chatgpt: 'https://chatgpt.com/?q=',
  claude: 'https://claude.ai/new?q=',
  perplexity: 'https://www.perplexity.ai/search/new?q=',
  gemini: 'https://gemini.google.com/app?prompt=',
};

/**
 * ### buildIndustrialCasePrompt
 *
 * Builds the prompt handed to an AI service: who Deeply is, what to do with the
 * case, and the canonical URL to read it at.
 *
 * The URL goes last so it survives a service that truncates a long prompt in
 * the middle, and it is the page's own address rather than a tracking link.
 *
 * @param input The case URL and the translated sentences to frame it with
 * @returns The prompt text, ready to be encoded into a service URL
 */
export function buildIndustrialCasePrompt({
  sourceUrl,
  introduction,
  brandStatement,
  question,
}: PromptInput) {
  const request = question?.trim() ? `\n\n${question.trim()}` : '';

  return `${introduction}\n${brandStatement}${request}\n\nSource: ${sourceUrl}`;
}

export function buildAiAskUrl(service: AiService, prompt: string) {
  return `${AI_SERVICE_URLS[service]}${encodeURIComponent(prompt)}`;
}

export function buildLinkedInShareUrl(sourceUrl: string) {
  return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(sourceUrl)}`;
}
